// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';
import { v1AppUserSchema } from './v1/appUserSchema';
import { v1NotFoundErrorSchema } from './v1/notFoundErrorSchema';

export const showAccountAppPathParamsSchema = z.object({
  account_id: z.number().int().describe("Workspace id"),
  app_id: z.number().int().describe("App id"),
});

export const showAccountAppHeaderParamsSchema = z.object({
  Authorization: z.optional(z.coerce.string()),
});

/**
 * @description App connection details
 */
export const showAccountApp200Schema = z.array(z.lazy(() => v1AppUserSchema));

/**
 * @description App not found
 */
export const showAccountApp404Schema = z.lazy(() => v1NotFoundErrorSchema);

export const showAccountAppQueryResponseSchema = z.lazy(() => showAccountApp200Schema);
